import L from 'leaflet';

/**
 * Lot 10 : helpers purs de lisibilité des tracés (découpage aller / milieu / retour, opacité au survol). Aucune règle de calcul :
 * la géométrie et les km restent ceux de l'api.
 */

/** Distance sous laquelle un point de la route est réputé « au PAV » (m). */
export const SEUIL_COUPE_M = 30;
/** Facteur d'opacité des journées non survolées pendant le survol d'une autre. */
export const FACTEUR_ESTOMPE = 0.3;

const distance = (a, b) => L.latLng(a).distanceTo(L.latLng(b));

/** Index du premier point sous le seuil, sinon du plus proche (premier en cas d'égalité). */
export function indexCoupeDepuisDebut(route, cible) {
    let meilleur = 0;
    let dMin = Infinity;
    for (let i = 0; i < route.length; i += 1) {
        const d = distance(route[i], cible);
        if (d < SEUIL_COUPE_M) return i;
        if (d < dMin) { dMin = d; meilleur = i; }
    }
    return meilleur;
}

/** Index du dernier point sous le seuil, sinon du plus proche en partant de la fin. */
export function indexCoupeDepuisFin(route, cible) {
    let meilleur = route.length - 1;
    let dMin = Infinity;
    for (let i = route.length - 1; i >= 0; i -= 1) {
        const d = distance(route[i], cible);
        if (d < SEUIL_COUPE_M) return i;
        if (d < dMin) { dMin = d; meilleur = i; }
    }
    return meilleur;
}

/**
 * Trois morceaux d'une journée : aller (base → premier PAV), milieu (premier → dernier PAV), retour (dernier PAV → base).
 * `route` : géométrie routière base → visites → base (positions Leaflet), ou null. `calque` : {points[{position}], trace,
 * depart, retour, aTrajet}. Les points de coupe appartiennent aux deux morceaux voisins.
 */
export function morceauxTrace({route, calque}) {
    const points = calque?.points || [];
    if (route && route.length > 1) {
        if (!calque.aTrajet || points.length === 0) return {aller: [], milieu: route, retour: []};
        const i1 = indexCoupeDepuisDebut(route, points[0].position);
        const i2 = Math.max(i1, indexCoupeDepuisFin(route, points[points.length - 1].position));
        return {aller: route.slice(0, i1 + 1), milieu: route.slice(i1, i2 + 1), retour: route.slice(i2)};
    }
    const milieu = calque?.trace || points.map((p) => p.position);
    if (points.length === 0) return {aller: [], milieu, retour: []};
    return {
        aller: calque.depart ? [calque.depart, points[0].position] : [],
        milieu,
        retour: calque.retour ? [points[points.length - 1].position, calque.retour] : [],
    };
}

/** Facteur d'opacité d'un calque : 0,3 seulement si une autre journée est survolée et que celui-ci n'est ni survolé ni actif. */
export function opaciteCalque({cle, survol, active}) {
    if (!survol || active || survol === cle) return 1;
    return FACTEUR_ESTOMPE;
}
